import { playFade, playSplitText } from "../common/help_functions";

export function faqSection(element) {
    faqAnimation();
    playFade('.title', true)
}

function faqAnimation() {
    //sorted accordion
    let $grid = $('#accordion').isotope({
        itemSelector: '.panel',
        layoutMode: 'fitRows',
        getSortData: {
            position: '[data-position] parseInt',
        },
        sortBy: 'position'
    });

    $('#accordion').on('show.bs.collapse', function (e) {
        console.log('here')
        setTimeout(function () {
            $(e.target).parent().toggleClass('active');
            $grid.isotope('updateSortData').isotope();
        }, 400);
        $(e.target).parent().attr('data-position', 1);
        $(e.target).parent().find('.icon-wrap').fadeOut(400);
    });

    $('#accordion').on('shown.bs.collapse', function () {
        $grid.isotope('updateSortData').isotope();
        $(this).find('.panel-collapse.in').parent().find('.icon-wrap').html('<i class="icon icon-minus"></i>').fadeIn(400);
    });

    $('#accordion').on('hide.bs.collapse', function (e) {
        setTimeout(function () {
            $(e.target).parent().toggleClass('active');
            $grid.isotope('updateSortData').isotope();
        }, 400);
        let oldposition = $(e.target).parent().data('oldposition',);
        $(this).find('.panel-collapse.in').parent().find('.icon-wrap').fadeOut(400);
        $(e.target).parent().attr('data-position', oldposition);
    });

    $('#accordion').on('hidden.bs.collapse', function (e) {
        $grid.isotope('updateSortData').isotope();
        $(e.target).parent().find('.icon-wrap').parent().find('.icon-wrap').html('<i class="icon icon-plus"></i>').fadeIn(400);
    });
}

// import WOW from 'wow.js';

// //init wow animation
// new WOW().init();
